import { useLocation, Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const Layout: React.FC = () => {
    const location = useLocation();
    const hideNavbarRoutes = ['/login'];

    const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);
    return (
        <>
            {!shouldHideNavbar && <Navbar/>}
            <main>
                <Outlet/>
            </main>
        </>
    )
}

export default Layout